import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import ItemList from '../Form/ItemList';

@inject("metaDataStore")
@observer
class MetaDataList extends Component {
  render() {
    const { metaDataStore,children } = this.props;

    return (
       <ItemList
        store = {metaDataStore}
        columns = {[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name' },
          { key: 'caption', label: 'Caption' },
          { key: 'description', label: 'Description' },
        ]}
        slug = {'configurations/meta-data/meta-data'}
        resource='meta-data'
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />
    );
  }
}

export default MetaDataList;



// WEBPACK FOOTER //
// ./src/components/MetaData/MetaDataList.js